export default {
	SET_PLATFORM_NOTIFICATIONS: (state, data) => state.platformNotifications = data,
	ADD_PLATFORM_NOTIFICATION: (state, data) => state.platformNotifications.push(data),
	SET_ACCESS_TOKEN: (state, token) => state.accessToken = token
}